import moment from "moment";

import socketActions from "./socketActions";

const initialState = {
  socketTimeoutMs: 0,
  isConnected: false,
  lastUpdated: moment(),
};

export const STATE_KEY = "socket";

const socketReducer = (state = initialState, action) => {
  switch (action.type) {
    case socketActions.SOCKET_LOST_CONNECTION:
      return {
        ...state,
        isConnected: false,
      };
    case socketActions.SOCKET_GOT_CONNECTION:
      return {
        ...state,
        isConnected: true,
      };
    case socketActions.SOCKET_TIMEOUT:
      return {
        ...state,
        timeoutMs: state.timeoutMs + action.payload.timeoutMs,
      };
    case socketActions.TOUCH:
      return {
        ...state,
        lastUpdated: action.payload.lastUpdated,
      };
    default:
      return state;
  }
};

export default socketReducer;
